import { render, staticRenderFns } from "./GlobalConfigUpdateDialogTrimmingCost.vue?vue&type=template&id=108310c6&scoped=true"
import script from "./GlobalConfigUpdateDialogTrimmingCost.vue?vue&type=script&lang=ts"
export * from "./GlobalConfigUpdateDialogTrimmingCost.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108310c6",
  null
  
)

export default component.exports